import React from "react";
import {Button, Popconfirm} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";
import {useStore} from "../../../../../../../hooks/useStore";

export const UnassignAllowedPermissionPolicyButton = ({
    userId,
    permissionPolicyKey,
    recall = () => {}
}) => {
    const stores = useStore();
    const {t} = useTranslation(["userAuthorization"]);

    return (
        <Popconfirm
            title={t("components.unassignAllowedPermissionPolicyButton.title", {
                ns: "userAuthorization"
            })}
            onConfirm={async () => {
                const unassignAllowedPermissionPolicyResult = await stores.userStore.unassignAllowedPermissionPolicy(
                    {userId, permissionPolicyKey}
                );
                if (!unassignAllowedPermissionPolicyResult.success) return;
                recall();
            }}
            okText={t("modal.yesButton", {ns: "common"})}
            cancelText={t("modal.noButton", {ns: "common"})}
            placement="left"
        >
            <Button
                data-testid="unassignAllowedPermissionPolicyButton"
                disabled={false}
                loading={false}
                icon={<DeleteOutlined />}
                onClick={e => e.stopPropagation()}
            ></Button>
        </Popconfirm>
    );
};
